module.exports = __webpack_public_path__ + "img/56.800b5699.png";